//import { debugger } from "fusioncharts";

import store from "@/store";
import moment from "moment-timezone";

const util = {
  timeZone: [
    { value: "America/New_York", text: "Eastern Time, ET, New York, NY" },
    { value: "America/Chicago", text: "Central Time, CT, Chicago, IL" },
    { value: "America/Denver", text: "Mountain Time, MT, Denver, CO" },
    {
      value: "America/Phoenix",
      text: "Mountain Standard Time, MST, Phoenix, AZ",
    },
    { value: "America/Los_Angeles", text: "Pacific Time, PT, Los Angeles, CA" },
    { value: "America/Anchorage", text: "Alaska Time, AKT, Anchorage, AK" },
    {
      value: "Pacific/Honolulu",
      text: "Hawaii Standard Time, HST, Honolulu, HI",
    },
    // {value: 'America/Anchorage', text: 'America/Anchorage'}
  ],
  colorArr: [],

  // Same as web util.getcolorindex — only real numbers count as taken slots.
  getcolorindex(colorindexlist: any) {
    const used = (colorindexlist || []).map((c) => util.storedColorIndex(c)).filter((c) => c != null);
    for (let i = 0; i < 15; i++) {
      if (!used.includes(i)) return i;
    }
    return 0;
  },

  storedColorIndex(value: any): number | null {
    if (typeof value === "number" && Number.isFinite(value) && value >= 0) return value;
    if (typeof value === "string" && value.trim() !== "" && !Number.isNaN(Number(value))) {
      const n = Number(value);
      return n >= 0 ? n : null;
    }
    return null;
  },

  findPropertyEntry(user: any, propertyId: any) {
    if (!user?.propertylist || propertyId == null) return null;
    return user.propertylist.find((p: any) => String(p.id) === String(propertyId)) || null;
  },

  // Same rules as web util.resolveUserColorIndex: master → user.colorindex,
  // everyone else → propertylist[property].colorindex. "4" and 4 are the same slot.
  resolveUserColorIndex(user: any, propertyId: any): number | null {
    if (user?.msteruser) {
      const fromUser = util.storedColorIndex(user.colorindex);
      if (fromUser != null) return fromUser;
    } else {
      const fromProp = util.storedColorIndex(util.findPropertyEntry(user, propertyId)?.colorindex);
      if (fromProp != null) return fromProp;
    }
    return util.storedColorIndex(user?.colorindex);
  },

  // Same as web util.ensureUserColorIndices. Assign every team member once,
  // in API list order, so a user who only appears on another day still claims
  // their slot (web calendar paints the whole month; mobile shows one day).
  ensureUserColorIndices(propertyUsers, propertyId, companyId, vuexStore = store, priorityIds: any[] = []) {
    const users = propertyUsers || [];
    const usedIndexes: number[] = [];

    users.forEach((user) => {
      const idx = util.resolveUserColorIndex(user, propertyId);
      if (idx != null && !usedIndexes.includes(idx)) usedIndexes.push(idx);
    });

    const orderedUsers: any[] = [];
    const seen = new Set();
    (priorityIds || []).forEach((pid) => {
      const user = users.find((u) => u.id === pid || u.kazooid === pid);
      if (user && !seen.has(user)) {
        seen.add(user);
        orderedUsers.push(user);
      }
    });
    users.forEach((user) => {
      if (!seen.has(user)) {
        seen.add(user);
        orderedUsers.push(user);
      }
    });

    orderedUsers.forEach((user) => {
      if (util.resolveUserColorIndex(user, propertyId) != null) return;
      const idx = util.getcolorindex(usedIndexes);
      usedIndexes.push(idx);
      const userproperty = util.findPropertyEntry(user, propertyId);
      if (userproperty && !user.msteruser) userproperty.colorindex = idx;
      else user.colorindex = idx;
      if (vuexStore && companyId && propertyId) {
        vuexStore.dispatch("notifyusercolorindexsave", {
          companyid: companyId,
          propertyid: propertyId,
          userid: user.id,
          colorindex: idx,
        }).catch(() => {});
      }
    });
  },
  // Schedule chip palette — colorindex 0–14. Same as web util.getNotifyColor.
  // HS-018: only the two light chips (yellow-green + bright yellow) are darkened
  // so white name/initials text stays readable.
  notifyColors: [
    [103, 59, 184, 1], [158, 168, 24, 1], [1, 150, 136, 1],
    [4, 169, 245, 1], [184, 148, 8, 1], [123, 123, 123, 1],
    [156, 40, 177, 1], [102, 188, 0, 1], [245, 128, 55, 1],
    [48, 60, 128, 1], [254, 193, 7, 1], [65, 150, 68, 1],
    [206, 16, 16, 1], [235, 131, 231, 1], [232, 30, 98, 1],
  ] as number[][],

  getNotifyColor(index: any, _propertyId?: string) {
    const colors = util.notifyColors;
    const slot = ((parseInt(index, 10) || 0) % colors.length + colors.length) % colors.length;
    const [c, g, b, a] = colors[slot] || colors[0];
    return `rgba(${c},${g},${b},${a})`;
  },

  getTagColor(index: any) {
    var colors = [
      [103, 59, 184, 1],
      [205, 220, 57, 1],
      [1, 150, 136, 1],
      [4, 169, 245, 1],
      [123, 123, 123, 1],
      [156, 40, 177, 1],
      [102, 188, 0, 1],
      [245, 128, 55, 1],
      [48, 60, 128, 1],
      [254, 193, 7, 1],
      [65, 150, 68, 1],
      [206, 16, 16, 1],
      [235, 131, 231, 1],
      [232, 30, 98, 1],
    ];
    var x = colors[index];
    if (!x) {
      index = Math.floor(Math.random() * 13);
      x = colors[index];
    }
    let c = colors[0][0];
    let g = colors[0][1];
    let b = colors[0][2];
    let a = colors[0][3];
    if (x && x.length == 4) {
      c = x[0];
      g = x[1];
      b = x[2];
      a = x[3];
    }

    return `rgb(${c}, ${g}, ${b})`;
  },

  randomColor(key: any, users, property_id, companyid) {
    const user = (users || []).find((u) => u.id === key || u.kazooid === key);
    if (!user) return util.getNotifyColor(13, property_id);

    const usercolorindex = util.resolveUserColorIndex(user, property_id);
    if (usercolorindex == null) return util.getNotifyColor(13, property_id);
    return util.getNotifyColor(usercolorindex, property_id);
  },
  formaReportTime(momentTZ, value, addsuffix = true) {
    const time = parseInt(value);
    var hour = Math.floor(time / 3600);
    const minutes = Math.floor(time / 60) - hour * 60;
    const sconds = time % 60;
    const minutes_str = minutes.toString().padStart(1, "0");
    const sconds_str = sconds.toString().padStart(1, "0");
    const hour_str = hour.toString().padStart(1, "0");
    if (hour > 0) return `${hour}h ${minutes_str}m`;
    else if (minutes > 0) return `${minutes}m ${sconds_str}s`;
    else return `0m ${sconds_str}s`;
  },
  formatDayOrDate(timestamp: any, prop_timezone: string) {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const date = moment(timestamp);
    const currentTime = moment().tz(prop_timezone);

    const elapsedDays = currentTime.diff(date, "days");

    if (elapsedDays === 0) {
      return "Today";
    } else if (elapsedDays === 1) {
      return "Yesterday";
    } else if (elapsedDays <= 6) {
      return days[date.day()];
    } else {
      return date.format("M/D/YY");
    }
  },

  createFormDataFromPayload(payload: Record<string, unknown>): FormData {
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (key === "phoneNumbers") {
        formData.append(key, JSON.stringify(value));
      } else if (["media", "recepients"].includes(key)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            if (item instanceof Blob || typeof item === "string") {
              formData.append(key, item);
            }
          });
        } else if (typeof value === "string") {
          formData.append(key, value);
        }
      } else if (value !== undefined && value !== null) {
        if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
          formData.append(key, value.toString());
        } else if (value instanceof Blob) {
          formData.append(key, value);
        } else {
          formData.append(key, JSON.stringify(value));
        }
      }
    });

    return formData;
  },

  compressImage(file: File, maxSizeBytes: number = 1048576): Promise<File> {
    return new Promise((resolve, reject) => {
      // If the file is already smaller than target size, return it as is
      if (file.size <= maxSizeBytes) {
        resolve(file);
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target?.result as string;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          let width = img.width;
          let height = img.height;

          // For very large images, resize dimensions first
          const MAX_WIDTH = 1920;
          const MAX_HEIGHT = 1920;

          if (width > MAX_WIDTH || height > MAX_HEIGHT) {
            const ratio = Math.min(MAX_WIDTH / width, MAX_HEIGHT / height);
            width *= ratio;
            height *= ratio;
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext("2d");
          ctx?.drawImage(img, 0, 0, width, height);

          // Function to compress with different quality settings
          const compress = (q: number) => {
            return canvas.toDataURL(file.type, q);
          };

          // Binary search to find optimal quality setting
          const findOptimalQuality = (min: number, max: number, attempts: number = 5): number => {
            if (attempts <= 0 || max - min < 0.01) {
              return min;
            }

            const mid = (min + max) / 2;
            const dataUrl = compress(mid);
            const byteString = atob(dataUrl.split(",")[1]);
            const sizeInBytes = byteString.length;

            if (sizeInBytes > maxSizeBytes) {
              return findOptimalQuality(min, mid, attempts - 1);
            } else {
              return findOptimalQuality(mid, max, attempts - 1);
            }
          };

          const optimalQuality = findOptimalQuality(0.1, 1.0);
          const dataUrl = compress(optimalQuality);

          // Convert data URL to Blob
          const byteString = atob(dataUrl.split(",")[1]);
          const mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0];
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);

          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }

          const blob = new Blob([ab], { type: mimeString });
          const compressedFile = new File([blob], file.name, { type: file.type });

          resolve(compressedFile);
        };

        img.onerror = () => {
          reject(new Error("Failed to load image"));
        };
      };

      reader.onerror = () => {
        reject(new Error("Failed to read file"));
      };
    });
  },

  /**
   * Gets a fallback language code if the user's language code is not provided or empty
   * @param userLanguageCode - The user's language code
   * @returns Language code (defaults to 'en' if not provided)
   */
  getFallbackLanguageCode(userLanguageCode?: string): string {
    return userLanguageCode && userLanguageCode.trim() !== "" ? userLanguageCode : "en";
  },

  /**
   * Gets a fallback language name if the user's language is not provided or empty
   * @param userLanguage - The user's language name
   * @returns Language name (defaults to 'English' if not provided)
   */
  getFallbackLanguage(userLanguage?: string): string {
    return userLanguage && userLanguage.trim() !== "" ? userLanguage : "English";
  },
};

export default util;
